import { useDispatch } from 'react-redux';
import { Button, Input } from '@safedns/skydns-ui-react-lib';

import { notificationSuccess } from '../../store/notificationReducer';

import useValidateDomain from '../../hooks/useValidateDomain';

import { useGetUserQuery, useCreateDomainMutation } from '../../services/ADapi';

import styles from './DomainForm.module.scss';

const CreateDomain = () => {
  const dispatch = useDispatch();

  const {
    data: { user_id },
  } = useGetUserQuery();
  const [createDomain] = useCreateDomainMutation();

  const {
    name,
    nameIsBlur,
    nameError,
    formIsValid,
    formIsSuccess,
    nameHandler,
    blurHandler,
    setName,
    setNameError,
    setFormIsValid,
    setFormIsSuccess,
  } = useValidateDomain();

  const notification = {
    isNotification: true,
    type: 'success',
    action: 'create_domain',
    message: `${name} создан`,
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      await createDomain({
        user_id,
        body: { name },
      });

      dispatch(notificationSuccess(notification));
    } catch (error) {
      console.error(error);
    }

    setFormIsSuccess(!formIsSuccess);
    setFormIsValid(false);

    setName('');
    setNameError(' ');
  };

  return (
    <form className={styles['form-container']} onSubmit={submitForm}>
      <div className={styles['form-row']}>
        <div className={styles['input-wrapper']}>
          <Input
            id="domainName"
            name="domain"
            label="Введите полное имя домена"
            value={name}
            size="medium"
            placeholder="Ввести имя домена"
            onChange={nameHandler}
            onBlur={blurHandler}
          />
        </div>

        <div className={styles['button-wrapper']}>
          <Button
            type="submit"
            size="large"
            variant="primary"
            isDisabled={!formIsValid}
          >
            Создать
          </Button>
        </div>
      </div>
      {nameIsBlur && nameError && (
        <span className="validate-error">{nameError}</span>
      )}
    </form>
  );
};

export default CreateDomain;
